module.exports = {
  ACTIVE_CUSTOMERS_REPORT_LIST_REQUEST: "ACTIVE_CUSTOMERS_REPORT_LIST_REQUEST",
  ACTIVE_CUSTOMERS_REPORT_LIST_SUCCESS: "ACTIVE_CUSTOMERS_REPORT_LIST_SUCCESS",
  ACTIVE_CUSTOMERS_REPORT_LIST_FAIL: "ACTIVE_CUSTOMERS_REPORT_LIST_FAIL",
};
